export function findNodeInTree<T extends { id: string; children?: T[] }>(tree: T[], id: string): T | undefined {
  for (const node of tree) {
    if (node.id === id) {
      return node;
    }

    const foundInChildren = findNodeInTree(node.children || [], id);
    if (foundInChildren) {
      return foundInChildren;
    }
  }

  return undefined;
}
